var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.stockList.length > 0)?_c('div',{staticClass:"card"},[_c('StockList',{attrs:{"stockList":_vm.GetStockList},on:{"reload":_vm.loadData,"dateChanged":_vm.loadData}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }